import React from "react";

export default ({ title, children, className="" }) => (
  <div className={`EditForm color--userLight bg--white page-pad ${className}`}>
    <h1 className="font--h2 bold genre-heading color--user">{title}</h1>
    <div className="">{children}</div>
  </div>
)